
import { InputCheckboxGroup, type CheckboxOptionType } from "@/components/input-checkbox-group";
import { InputText } from "@/components/input-text";
import Modal from "@/components/modal/Modal";
import { useState } from "react";
import "./export-data.css"

interface ExportDataProps {
    isOpen: boolean;
    options: CheckboxOptionType[];
    onCancel: () => void;
    onExport: (columns: string[], name?: string) => void;
}

export const ExportData = ({isOpen=false, options, onCancel, onExport}: ExportDataProps) => {

    const [selectedCategories, setSelectedCategories] = useState<string[]>([]);
    const [name, setName] = useState("")

    return (
        <Modal 
            cancelText="Annuler"
            confirmText="Exporter"
            isOpen={isOpen}
            title="Exporter les données"
            onCancel={() => {
                setSelectedCategories([]);
                onCancel()}}
            onConfirm={() => onExport(selectedCategories, name)}
        >
            <form className="export-data-form">
                <InputText 
                    className="export-data-text-input" 
                    name="title" label="Nom du rapport" 
                    placeholder="Nom du rapport"
                    onChange={(e) =>
                        setName(e.target.value)
                    }/>
                <InputCheckboxGroup 
                    label="Catégories à exporter" 
                    options={options} 
                    value={selectedCategories}
                    onChange={setSelectedCategories}
                />
            </form>
        </Modal>
)};